import { Select } from "../utilities";
import { QueovalDateTime, GQueovalDik, QueovalDate } from '../global';


export class Invoice {
  public Ident: string;
  public Name: string;
  public Path: string;
  public Date: QueovalDateTime;
  public ReadOnly: boolean;
  public DevisPerdu: boolean;
  public DatePerdu: QueovalDate;
  public DevisSigne: boolean;
  public DateSignature: QueovalDate;

  constructor() {
    this.Date = new QueovalDateTime();
  }
}


export class Corporation {
  public Id: string;
  public SocialReason: string;
  public HomePhoneNumber: string;
  public PhoneNumber: string;
  public Email: string;
  public MailTo: string;
  public PersonneMorale: string;
  public IsClient: boolean;
  public PCCity: string;
  public IsIndividuel: boolean;
  constructor() {
    this.Id = '';
    this.SocialReason = '';
    this.HomePhoneNumber = '';
    this.PhoneNumber = '';
    this.Email = '';
    this.MailTo = '';
    this.PersonneMorale = 'Personne Morale';
    this.IsClient = false;
    this.PCCity = '';
    this.IsIndividuel = false;
  }
}

export class Person {
  public Id: string;
  public Civility: string;
  public Value: string;
  public Firstname: string;
  public Lastname: string;  
  public PhoneNumber: string;
  public MobilePhoneNumber: string;
  public Email: string;
  public MailTo: string;
  public ProfilePicture: string;
  public IsSelected: boolean;
}

export class ActionCoHistory {
  public Id: string;
  public BoTypeValue: string;
  public BoTypeText: string;
  public BoTypes: Array<Select>;
  public Person: Person;
  public Date: QueovalDateTime;
  public Type: ActionCoHistoryType;
  public Label: string;
  public Value: string;
  public ReadOnly: boolean;
  public Responses: Array<ActionCoResponse>;
  public MaxLengthValue: number;
}
export class ActionCoResponse {
  public Person: string;
  public Date: QueovalDateTime;
  public Value: string;
}

export class ActionCoReply {
  public HistoryId: string;
  public Value: string;
}
export enum ActionCoHistoryType {
  comment = 'comment',

  quoteCreate = 'quoteCreate',
  quoteUpdate = 'quoteUpdate',
  quoteGeneration = 'quoteGeneration',
  quoteWin = 'quoteWin',
  quoteLose = 'quoteLose',

  sendMail = 'sendMail',

  createAction = 'createAction',
  updateAction = 'updateAction',
  win = 'win',
  lose = 'lose'
}
export enum ActionCoTypeDevis {
  CAC = 'CAC',
  lettreDeMission = 'LDM',
  Devis = 'DEVIS',
  Produit = 'PRODUIT'
}


